export default class TeachersAPI {
    private services: any;
  
    constructor(services) {
      this.services = services;
    }
  
    public getCoursesSummary({ institutionID }) {
      return this.services.baseAPI
        .get(`/teachers/courses?institutionid=${institutionID}`, false);
    }
    
    public teacherJoinSchool(itemData) {
        return this.services.baseAPI
          .post(`teachers/join`, itemData, false);
    }

    public getInstitutionsOverallAssessmentStats(institutionID, assessmentID) {
      return this.services.baseAPI.get(`teachers/${institutionID}/assessments/${assessmentID}/overall_stats`)
    }
  
    public getCourseDetails({ institutionID, courseID }) {
      return this.services.baseAPI
        .get(`/teachers/course/details?institutionid=${institutionID}&courseid=${courseID}`, false);
    }

    public getInstitutionsProfile() {
      return this.services.baseAPI.get(`teachers/profile`)
    }
  
    public getInstitutionAssessmentSearchFilters(assessmentID) {
      return this.services.baseAPI.get(`teachers/search_filters/assessments/${assessmentID}/`)
    }
  
    public getInstitutionAssessmentLevelsBreakdown(assessmentID) {
      return this.services.baseAPI.get(`teachers/alert_levels/assessments/${assessmentID}/`)
    }

    public getInstitutionAssessmentStudentSearchFiltered(searchFilterID,assessmentID) {
      return this.services.baseAPI.get(`teachers/search_filters/${searchFilterID}/assessments/${assessmentID}/`)
    }

    public getSchoolStudents() {
      return this.services.baseAPI
        .get(`teachers/student_members/`, false);
    }

    // new store migration

    public getInstitutionsAssessments() {
      return this.services.plBaseAPI.get(`teachers/assessments/list`)
    }

    public getCohortsList(assessmentId) {
      return this.services.plBaseAPI.get(`teachers/assessments/cohorts/${assessmentId}`)
    }

    public getYearGroups() {
      return this.services.plBaseAPI.get(`teachers/assessments/yeargroups`)
    }

    public getDepartments() {
      return this.services.plBaseAPI.get(`teachers/assessments/departments`)
    }

     public getLearnersCohortAssessmentStats( assessmentID, cohort, searchQuery) {
      return this.services.plBaseAPI.get(`teachers/assessments/cohort_stats/${cohort}/${assessmentID}?${searchQuery}`);
    }

    public getLearnersAssessmentLevelsBreakdown(assessmentID, cohort, searchQuery) {

      return this.services.plBaseAPI.get(`teachers/assessments/cohort_overview/${cohort}/${assessmentID}?${searchQuery}`);
    }

      public getInstitutionStudentsRiskGroup(assessmentId, alertId, cohort) {
      return this.services.plBaseAPI.get(`teachers/assessments/cohort_alert_list/${cohort}/${assessmentId}/levels/${alertId}`)
    }

    public getCohortsPerceptionData = (cohort, perceptionId) => {
      return this.services.plBaseAPI.get(`teachers/assessments/cohort_perception_list/${cohort}/perceptions/${perceptionId}`)
    }

    public getGlobalCohortsList = () => {
      return this.services.plBaseAPI.get(`teachers/assessments/global_cohorts_list`)
    }
    public getCohortPerceptionStudents = (cohort, perception) => {
      return this.services.plBaseAPI.get(`teachers/assessments/cohort_perception_list/${cohort.split('-').join('_')}/perceptions/${perception}`)
    }

    public getAssessmentSearchFilters(assessmentId) {
      return this.services.plBaseAPI.get(`teachers/assessments/sf_list/${assessmentId}`)
    }

    public  getSearchFiltersStudents(assessment, sf) {
      return this.services.plBaseAPI.get(`teachers/assessments/search_filters/${sf}/student_list/${assessment}/`)
    }

    public getAllCoursesSummary(startDate, endDate) {
      return this.services.plBaseAPI.get(`teachers/courses/summaries/${startDate}/${endDate}`);
    }

    public getCourseEnrolledLearners(courseId, startDate, endDate) {
      return this.services.plBaseAPI.get(`teachers/courses/${courseId}/enrolled_learners/${startDate}/${endDate}/list`);
    }

    public getSingleCourseSummary(courseId, startDate, endDate) {
      return this.services.plBaseAPI.get(`teachers/courses/${courseId}/summary/${startDate}/${endDate}`);
    }

    public getLessonSummary(courseId, lessonId, startDate, endDate) {
      return this.services.plBaseAPI.get(`teachers/courses/${courseId}/lessons/${lessonId}/${startDate}/${endDate}/summary`);
    }

    public getLessonLearners(courseId, lessonId, startDate, endDate) {
      return this.services.plBaseAPI.get(`teachers/courses/${courseId}/lessons/${lessonId}/${startDate}/${endDate}/learners`)
    }

    public getLeastActiveLearners(startDate, endDate) {
      return this.services.plBaseAPI.get(`teachers/least_active_learners/${startDate}/${endDate}/list`);
    }
    public getInactiveLearners(startDate, endDate) {
      return this.services.plBaseAPI.get(`teachers/inactive_learners/${startDate}/${endDate}/list`);
    }
  }


// WEBPACK FOOTER //
// ./src/services/API/v1/Teachers.ts